const MAX_IMAGE_WIDTH = 1600;
const MAX_IMAGE_HEIGHT = 2400;
const WEBP_QUALITY = 0.8;

function toWebpName(filename: string): string {
  const base = filename.replace(/\.[^.]+$/, '') || 'portfolio-image';
  return `${base}.webp`;
}

export async function optimizeImageForUpload(file: File): Promise<File> {
  if (!file.type.startsWith('image/') || file.type === 'image/gif') return file;

  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(
      1,
      MAX_IMAGE_WIDTH / bitmap.width,
      MAX_IMAGE_HEIGHT / bitmap.height,
    );
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d', { alpha: true });
    if (!context) {
      bitmap.close();
      return file;
    }

    context.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();

    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, 'image/webp', WEBP_QUALITY);
    });

    if (!blob || blob.size >= file.size) return file;
    return new File([blob], toWebpName(file.name), {
      type: 'image/webp',
      lastModified: Date.now(),
    });
  } catch {
    return file;
  }
}
